export const outlookDataFileFmt = "s8KWfd";
export default {outlookDataFileFmt};